import { render } from "./Main.vue?vue&type=template&id=171491b3"
const script = {}
script.render = render

export default script